import { createPatchAsyncSlice } from '@sonar-software/xuder';
import { patchSonarTaskTemplateConfig } from '@api';

export const coreSonarTaskConfigsByOrganizationIdAndTaskTypePatchAsyncSlice = createPatchAsyncSlice({
	name: 'CoreSonarTaskConfigsByOrganizationIdAndTaskType',
	receive: false,
	request: true,
	requestHandler: patchSonarTaskTemplateConfig
});
